import { DocumentPickerAsset } from 'expo-document-picker';

import { MAX_DOCUMENT_FILE_SIZE_IN_BYTES, MAX_DOCUMENT_FILE_SIZE_IN_MEGABYTES } from '../consts';

export function validateFilesSize(files: DocumentPickerAsset[]) {
	if (files.some((file) => file.size && file.size > MAX_DOCUMENT_FILE_SIZE_IN_BYTES)) {
		throw new Error(`File size should be less than ${MAX_DOCUMENT_FILE_SIZE_IN_MEGABYTES}MB`);
	}
}
